import { render, staticRenderFns } from "./BankingForm.vue?vue&type=template&id=6ff2f1bc&"
import script from "./BankingForm.vue?vue&type=script&lang=js&"
export * from "./BankingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports